
import { defineComponent } from 'vue'
import { computed } from 'vue'

import currency from 'currency.js'
import { PriceObject } from '@/types/commonTypes'

export default defineComponent({
	name: 'FormattedPrice',

	props: {
		price: {
			type: [Number, String],
			default: ''
		},
		topDecimalPart: {
			type: String,
			default: '2'
		},
		decimalHeight: {
			type: String,
			default: '60'
		}
	},

	setup(props) {
		const isPriceEmpty = computed<boolean>(
			() => !props.price && typeof props.price !== 'number'
		)

		const priceObj = computed<PriceObject>(() => {
			if (isPriceEmpty.value) return null

			const separatedPrice = currency(+props.price)
				.format()
				.split('.')

			return {
				integer: `${separatedPrice[0]}.`,
				decimal: separatedPrice[1]
			}
		})

		const decimalStyles = computed(() => ({
			top: `${props.topDecimalPart}px`,
			fontSize: `${props.decimalHeight}%`
		}))

		return { isPriceEmpty, priceObj, decimalStyles }
	}
})
